import { Box } from "@mui/material";
import { DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { RelativeDateDirection, RelativeDateReference, RelativeDateUnit } from "../../../annualWheel/RelativeDate.types.ts";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { RelativeTemplateDateConfigModel } from "../../../masterData/annualWheelActivityTemplate/customTemplateAddEditDialog/CustomTemplateAddEditDialog.types.ts";
import { isNullOrWhitespace } from "../../stringOperations.ts";

export interface TemplateRelativeDateConfigProps {
    config: RelativeTemplateDateConfigModel | undefined;
    errorMsg?: string;
    onValueChange: (value: string) => void;
    onUnitChange: (unit: string | undefined) => void;
    onDirectionChange: (direction: string | undefined) => void;
    onRelativeToChange: (relativeTo: string | undefined) => void;
}

function TemplateRelativeDateConfig(props: TemplateRelativeDateConfigProps) {
    const { translateString } = useTranslation();

    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ width: "53px" }}>
                    <DotLegalTextField
                        onlyNumber={"integer"}
                        label={""}
                        value={props.config?.value?.toString() ?? ""}
                        debounce={false}
                        minNumberValue={0}
                        noMargin
                        onChange={props.onValueChange}
                    />
                </Box>
                <DotLegalSelect
                    selectedItem={props.config?.unit?.toString() ?? ""}
                    options={[
                        { id: RelativeDateUnit.Days.toString(), name: translateString("days") },
                        { id: RelativeDateUnit.Weeks.toString(), name: translateString("weeks") },
                        { id: RelativeDateUnit.Months.toString(), name: translateString("months") },
                        { id: RelativeDateUnit.Years.toString(), name: translateString("years") },
                    ]}
                    onChange={(unit) => props.onUnitChange(unit ?? undefined)}
                    label={""}
                    placeholder={translateString("unit")}
                    noOptionsLabel={translateString("noOptions")}
                    noMargin
                    width={"150px"}
                />
                <DotLegalSelect
                    selectedItem={props.config?.direction?.toString() ?? ""}
                    options={[
                        { id: RelativeDateDirection.Before.toString(), name: translateString("before") },
                        { id: RelativeDateDirection.After.toString(), name: translateString("after") },
                    ]}
                    onChange={(direction) => props.onDirectionChange(direction ?? undefined)}
                    label={""}
                    placeholder={translateString("direction")}
                    noOptionsLabel={translateString("noOptions")}
                    noMargin
                    width={"150px"}
                />
                <Box sx={{ flex: 1 }}>
                    <DotLegalSelect
                        selectedItem={props.config?.relativeTo?.toString() ?? ""}
                        options={[
                            { id: RelativeDateReference.ContractStart.toString(), name: translateString("startDate") },
                            { id: RelativeDateReference.ContractEnd.toString(), name: translateString("endDate") },
                        ]}
                        onChange={(relativeTo) => props.onRelativeToChange(relativeTo ?? undefined)}
                        label={""}
                        placeholder={translateString("relativeTo")}
                        noOptionsLabel={translateString("noOptions")}
                        noMargin
                    />
                </Box>
            </Box>

            {!isNullOrWhitespace(props.errorMsg) && (
                <Box sx={{ whiteSpace: "pre-line", marginTop: 1, fontSize: "0.75rem", color: "error.main" }}>{props.errorMsg}</Box>
            )}
        </Box>
    );
}

export default TemplateRelativeDateConfig;
